import { oz } from '@weft/utils';
import { segregated } from '../../utils/segregated';
import { ContractSchema } from '../contract';
import { LineItemSchema } from '../line-item';
import { NewInvoiceSchema } from './new-invoices-schema';
import { InvoicePaymentProviderInformationSchema } from './payment-provider-information-schema';

export const InvoiceSchema = segregated(
  NewInvoiceSchema
    .omit({ contractId: true })
    .extend({
      purchaseOrder: oz.string().max(20).optional(),
      notes: oz.string().max(500).optional(),
      contract: ContractSchema.nullable(),
      lineItems: oz.array(LineItemSchema),
      paymentProviderInformation: InvoicePaymentProviderInformationSchema.optional(),
    }),
).openapi('Invoice');

export type Invoice = oz.infer<typeof InvoiceSchema>;